module.exports = __webpack_public_path__ + "static/media/FRENCH_Milan_WelcomeKit_021820.578e6d8c.pdf";